import { getMarketplaceHomeUrl } from '../../utils/marketplace'

/**
 * @deprecated Use `useLocations()` / `useLocationCascade()` from `src/hooks/useLocations.js`
 * (`regions-v2` / `districts-v2` / `communities-v2`). Kept empty so stray imports do not show stale hardcoded regions.
 */
export const REGIONS = []

export const OWNERSHIPTYPES = [
  "owned",
  "leased",
  "shared",
  "other"
]

export const PLATFORM_LINKS = {
  marketplace: getMarketplaceHomeUrl(),
  landingpage: "https://test-landingpage.farmerkonect.com/"
}
